import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { SharedModule } from '@whitehatgaming/shared';
import { CreateAccountComponent } from './create-account/create-account.component';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { brandConfig } from './brand-config';
import { environment } from '../environments/environment';
import { SafeHtmlPipe } from './safe-html.pipe';
import { ComplianceLogosComponent } from './compliance-logos/compliance-logos.component';

@NgModule({
  declarations: [AppComponent, CreateAccountComponent, SafeHtmlPipe, ComplianceLogosComponent],
  imports: [
    BrowserModule,
    AppRoutingModule, // first to declare wins
    SharedModule.forRoot(brandConfig, environment),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
